import * as React from 'react';
import { Modal } from '@bepure/tarkin';

interface State {
    isOpen: boolean;
}

class ShippingModal extends React.Component<{}, State> {

    constructor(props: {}) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    public render() {
        return (
            <React.Fragment>
                <button id={'shipping_modal-shipping_delivery_policy_cta'} className="text text--clear_button text--link text--link--primary text--hide_link" onClick={this.handleOpen}>
                    Shipping &amp; Delivery
                </button>
                <Modal
                    open={this.state.isOpen}
                    contentClassName=""
                    isSmall={true}
                    hasBackground={true}
                    handleClose={this.handleClose}
                >
                    <div className="padding--large">
                        <div className="text text--center text--heading-2 margin--small--bottom">
                            Eve Shipping and Delivery
                        </div>
                        <div className="text text--center text--body margin--small--bottom margin--medium--top">
                            Pre-orders will be sent out as soon as they're available in the next few weeks.
                        </div>
                        <div className="text text--center text--body margin--small--bottom">
                            We will keep you updated on when your test kit becomes available.
                        </div>
                        <div className="text text--center text--body margin--small--bottom">
                            Once the kit has been sent out, it should take between 1-3 business days to reach you.
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }

    private handleClose = () => {
        this.setState({
            isOpen: false,
        });
    }

    private handleOpen  = () => {
        this.setState({
            isOpen: true,
        });
    }
}

export default ShippingModal;
